/**
 * livevibe.ch — Blog Article Scripts
 * - Reading Progress Bar
 * - Inline Images: dezentes Ausbrechen max +10% (nur Body-Bilder, nicht Featured Image)
 * - Table Wrapping (responsive)
 * - Copy Link Button
 * Version: 1.3 — 2026-04-29
 * CHANGE: makeImagesFullBleed schliesst .lv-article-featured-image explizit aus.
 *         Featured Image ist jetzt erste Figure im Body — kein JS-Eingriff erwünscht.
 */

(function () {
  'use strict';

  /* -------------------------------------------
     Reading Progress Bar
  ------------------------------------------- */
  function initProgressBar() {
    var bar = document.getElementById('lv-progress-bar');
    if (!bar) return;

    function update() {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      var progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      bar.style.width = Math.min(progress, 100) + '%';
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* -------------------------------------------
     Inline Images — dezentes Ausbrechen max +10%
     Betrifft nur Body-Bilder (p > img im lv-article-body).
     .lv-article-featured-image bleibt unberührt — CSS steuert es.
  ------------------------------------------- */
  function makeImagesFullBleed() {
    var articleBody = document.querySelector('.lv-article-body');
    if (!articleBody) return;

    function applyFullBleed() {
      var bodyRect = articleBody.getBoundingClientRect();
      var bodyWidth = bodyRect.width;

      var maxExtra = bodyWidth * 0.05; // 5% pro Seite = max 10% total breiter
      var extraEachSide = Math.min(bodyRect.left, maxExtra);
      if (extraEachSide < 8) extraEachSide = 0; // Mobile: kein Ausbruch

      var pTags = articleBody.querySelectorAll('p');
      pTags.forEach(function (p) {
        // Nur p-Tags die genau ein img als einziges Child haben
        var children = Array.from(p.childNodes).filter(function (n) {
          return n.nodeType === 1 || (n.nodeType === 3 && n.textContent.trim() !== '');
        });
        if (children.length !== 1 || children[0].tagName !== 'IMG') return;

        p.classList.add('lv-img-full');

        if (extraEachSide > 0) {
          p.style.marginLeft  = '-' + extraEachSide + 'px';
          p.style.marginRight = '-' + extraEachSide + 'px';
          p.style.width = 'calc(100% + ' + (extraEachSide * 2) + 'px)';
        } else {
          p.style.marginLeft  = '0';
          p.style.marginRight = '0';
          p.style.width = '100%';
        }
        p.style.marginTop    = '3.2rem';
        p.style.marginBottom = '3.2rem';
        p.style.maxWidth     = 'none';
      });
    }

    applyFullBleed();
    window.addEventListener('resize', applyFullBleed, { passive: true });
  }

  /* -------------------------------------------
     Table Wrapping — wrap all tables in .lv-table-wrapper
  ------------------------------------------- */
  function wrapTables() {
    var articleBody = document.querySelector('.lv-article-body');
    if (!articleBody) return;

    var tables = articleBody.querySelectorAll('table');
    tables.forEach(function (table) {
      if (table.parentElement.classList.contains('lv-table-wrapper')) return;

      var hint = document.createElement('p');
      hint.className = 'lv-table-scroll-hint';
      hint.textContent = 'Horizontal scrollen zum Anzeigen';

      var wrapper = document.createElement('div');
      wrapper.className = 'lv-table-wrapper';

      table.parentNode.insertBefore(hint, table);
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  /* -------------------------------------------
     Copy Link Button
  ------------------------------------------- */
  function initCopyLink() {
    var btn = document.getElementById('lv-copy-link');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var url = window.location.href;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          btn.textContent = 'Kopiert!';
          btn.classList.add('copied');
          setTimeout(function () {
            btn.textContent = 'Link kopieren';
            btn.classList.remove('copied');
          }, 2000);
        });
      } else {
        // Fallback
        var ta = document.createElement('textarea');
        ta.value = url;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (err) {}
        document.body.removeChild(ta);
        btn.textContent = 'Kopiert!';
        btn.classList.add('copied');
        setTimeout(function () {
          btn.textContent = 'Link kopieren';
          btn.classList.remove('copied');
        }, 2000);
      }
    });
  }

  /* -------------------------------------------
     Lesezeit berechnen (~200 WPM)
  ------------------------------------------- */
  function calcReadingTime() {
    var el = document.getElementById('lv-reading-time');
    if (!el) return;

    var body = document.querySelector('.lv-article-body');
    if (!body) return;

    var text = body.innerText || body.textContent || '';
    var wordCount = text.trim().split(/\s+/).length;
    var minutes = Math.max(1, Math.ceil(wordCount / 200));
    el.textContent = minutes + ' Min. Lesezeit';
  }

  /* -------------------------------------------
     Init
  ------------------------------------------- */
  function init() {
    initProgressBar();
    makeImagesFullBleed();
    wrapTables();
    initCopyLink();
    calcReadingTime();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
